import { render } from "./PassionSlider.vue?vue&type=template&id=4f23c8fa&ts=true"
import script from "./PassionSlider.vue?vue&type=script&lang=ts"
export * from "./PassionSlider.vue?vue&type=script&lang=ts"

import "./PassionSlider.vue?vue&type=style&index=0&id=4f23c8fa&lang=stylus"

import exportComponent from "/builds/web-factory/barsmart/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__